export const ADD_TO_CACHE = 'ADD_TO_CACHE';
export const REMOVE_FROM_CACHE = 'REMOVE_FROM_CACHE';
export const RESET_CACHE = 'RESET_CACHE';
export const SET_CACHE = 'SET_CACHE';
